
import Vue from 'vue'
import RenderroButton from '@/components/forms/RButton.vue'
import { WorkstationDocument } from '@/api/types/workstation'
import { mapActions } from 'vuex'

export default Vue.extend({
  name: 'UserResources',
  components: {
    RenderroButton,
  },
  data() {
    return {
      workstations: [],
      displayName: '',
    }
  },
  methods: {
    ...mapActions({
      connectToWorkstationRDP: 'workstation/connectRDP',
      connectToWorkstationTGX: 'workstation/connectTGX',
      connectToWorkstationTeradici: 'workstation/connectTeradici',
    }),
    beforeOpen(event: any) {
      this.displayName = event.params.user.displayName
      this.workstations = event.params.user.workstations
    },
    connectRDP(workstation: WorkstationDocument) {
      // TODO For some reason workstation is plain object, should be WorkstationDocument already
      this.connectToWorkstationRDP(new WorkstationDocument({ ...workstation }))
    },
    connectTGX(workstation: WorkstationDocument) {
      // TODO For some reason workstation is plain object, should be WorkstationDocument already
      this.connectToWorkstationTGX(new WorkstationDocument({ ...workstation }))
    },
    connectTeradici(workstationUuid: string) {
      this.connectToWorkstationTeradici(workstationUuid)
    },
  },
})
